export default __webpack_public_path__ + "static/media/document-search-white.88a4528c.svg";